import type { Router } from 'vue-router'

let _router: Router | null = null

export function setRouter(router: Router) {
  _router = router
}

export function getRouter(): Router {
  if (!_router) {
    throw new Error('Router has not been set yet with setRouter in app setup')
  }
  return _router
}
